import WorkflowStages from './WorkflowStages';

const FormWorkflowStages = WorkflowStages;

export default FormWorkflowStages;
